<template>
  <div>
    <!-- Header -->
    <div class="relative flex justify-center items-center">
      <div class="absolute z-30 text-white px-6">
        <h1 class="text-4xl md:text-5xl leading-[50px] md:leading-[60px] font-serif text-center">{{ $t('about-us.title') }}</h1>
      </div>
      <div class="absolute z-20 inset-0 bg-black opacity-30"></div>
      <nuxt-img sizes="xl:100vw lg:100vw md:100vw sm:100vw xs:100vw" class="object-cover min-h-[400px] w-full md:aspect-[3]" src="/images/about-us.jpg"
        alt="About Us Hero Image" />
    </div>

    <!-- Main Content -->

    <div class="container mx-auto px-6 py-12 md:p-20">
      <p class="text-sm md:text-base mb-10 md:mb-16">{{ $t('about-us.description') }}</p>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 mb-10 md:mb-16">
        <div class="bg-gray-100 p-4 rounded-lg shadow-md">
          <h2 class="text-lg md:text-xl font-serif mb-2">{{ $t('about-us.activities.psychological-activities.title') }}</h2>
          <p class="text-sm md:text-base">{{ $t('about-us.activities.psychological-activities.description') }}</p>
        </div>
        <div class="bg-gray-100 p-4 rounded-lg shadow-md">
          <h2 class="text-lg md:text-xl font-serif mb-2">{{ $t('about-us.activities.personal-growth-initiatives.title') }}</h2>
          <p class="text-sm md:text-base">{{ $t('about-us.activities.personal-growth-initiatives.description') }}</p>
        </div>
        <div class="bg-gray-100 p-4 rounded-lg shadow-md">
          <h2 class="text-lg md:text-xl font-serif mb-2">{{ $t('about-us.activities.training.title') }}</h2>
          <p class="text-sm md:text-base">{{ $t('about-us.activities.training.description') }}</p>
        </div>
        <div class="bg-gray-100 p-4 rounded-lg shadow-md">
          <h2 class="text-lg md:text-xl font-serif mb-2">{{ $t('about-us.activities.collective-actions.title') }}</h2>
          <p class="text-sm md:text-base">{{ $t('about-us.activities.collective-actions.description') }}</p>
        </div>
      </div>

      <p class="text-sm md:text-base mb-8">{{ $t('about-us.team-description') }}</p>

      <p class="text-sm md:text-base mb-8">{{ $t('about-us.partnerships') }}</p>
    </div>
  </div>
</template>

<script setup>
</script>
